import { trendColor } from "../lib/format";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export function Panel({ title, icon, right, children, className = "", testid }) {
  return (
    <div className={`panel fade-up ${className}`} data-testid={testid}>
      {(title || right) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#1E293B]">
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-slate-300">
            {icon}
            <span>{title}</span>
          </div>
          {right}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export function TrendBadge({ trend, label, testid }) {
  const dir = trend?.direction ?? 0;
  const color = trendColor(dir);
  const Icon = dir > 0 ? TrendingUp : dir < 0 ? TrendingDown : Minus;
  return (
    <div className="panel-2 rounded-md px-3 py-2.5" data-testid={testid} style={{ borderColor: `${color}44` }}>
      <div className="eyebrow mb-1">{label}</div>
      <div className="flex items-center gap-2">
        <Icon size={16} style={{ color }} />
        <span className="font-display text-lg font-bold" style={{ color }}>{trend?.state || "—"}</span>
      </div>
      <div className="mt-1 flex items-center justify-between text-[11px] font-mono text-slate-400">
        <span>{trend?.days ?? 0}d in state</span>
        <span>{trend?.confidence ?? 0}% conf</span>
      </div>
    </div>
  );
}

export function FactorChip({ text, positive, testid }) {
  const color = positive ? "#10B981" : "#EF4444";
  return (
    <div
      data-testid={testid}
      className="text-[11px] font-mono px-2.5 py-1.5 rounded border flex items-start gap-1.5"
      style={{ borderColor: `${color}44`, background: `${color}12`, color: "#CBD5E1" }}
    >
      <span style={{ color }}>{positive ? "▲" : "▼"}</span>
      <span>{text}</span>
    </div>
  );
}

export function Stat({ label, value, color, mono = true }) {
  return (
    <div>
      <div className="eyebrow mb-0.5">{label}</div>
      <div className={`${mono ? "font-mono" : "font-display"} text-sm font-semibold tnum`} style={{ color: color || "#F8FAFC" }}>
        {value}
      </div>
    </div>
  );
}
